import * as angular from 'angular';

import { ComponentDefinition, Dictionary, DigitalSet } from '../../../../models';

class DigitalSetInfoTableController implements angular.IComponentController {
    readonly countDicitionary: Dictionary<number>;
    readonly set: DigitalSet;

    static $inject = [];
}

export const wtDigitalSetInfoTable: ComponentDefinition = {
    componentId: 'wtDigitalSetInfoTable',
    controller: DigitalSetInfoTableController,
    template: require('./digitalSetInfoTable.component.html'),
    controllerAs: 'vm',
    bindings: {
        countDictionary: '<',
        set: '<'
    }
};
